export default __webpack_public_path__ + "static/media/bukadonasi.8979f964.png";